var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconReload = function SvgIconReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 56,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28,
    r: 28,
    fill: "#EBEEF7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-reload_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#18223D",
    d: "M21.963 20.433A9.96 9.96 0 0 1 28.5 18c5.523 0 10 4.477 10 10 0 2.136-.67 4.116-1.81 5.74L33.5 28h3a8 8 0 0 0-13.54-5.772zm13.074 15.134A9.96 9.96 0 0 1 28.5 38c-5.523 0-10-4.477-10-10 0-2.136.67-4.116 1.81-5.74L23.5 28h-3a8.001 8.001 0 0 0 13.54 5.772z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-reload_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.5 16h24v24h-24z"
  })))));
};
export default SvgIconReload;